import { isInteger, isNumber } from '@vaaas/ts-validate';

/** validates that a number is positive finite real number */
export function PositiveNumber(x: unknown): x is number {
    return isNumber(x)
        && isFinite(x)
        && x > 0;
}

export function NonNegativeInteger(x: unknown): x is number {
    return isInteger(x) && x >= 0;
}
